import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { smoothlyMenu } from '../../../app.helpers';
// import { AuthService } from '../../../auth/auth.service';
declare var jQuery:any;
import { ToolbarComponent } from '@syncfusion/ej2-angular-navigations';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { IdleService } from './../../../services/idle.service';
import { HttpClient } from '@angular/common/http';
import { DemoService } from 'src/app/demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';
import { Subscription, filter } from 'rxjs';
import { AppVersionService } from '../../../services/app-version.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html',
  providers:[ToolbarComponent]
})
export class TopNavbarComponent implements OnInit, OnChanges, OnDestroy {

  @Input() idleTimeLeft: any;

  isShown: boolean = false ; // hidden by default
  force_logout: number;
  all_router_details: any;
  current_base_route: any;
  brand_user: Object;


  isShown_help: boolean = false ; // hidden by default
  isShown_help_vars: boolean = false ; // hidden by default
  isShown_help_routes: boolean = false ; // hidden by default
  isShown_under_the_hood: boolean = false ; // hidden by default
  legalNowDate = '';
  legalNowTime = '';
  userTimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Local';
  userNowDateTime = '';
  private legalClockTimer: any;
  private routerEventsSub?: Subscription;

  constructor(private idleService: IdleService, public gfunc: GlobalFunctionsService, public router: Router,
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    public legalDate: LegalDateTimeService,
    private appVersionService: AppVersionService,
    ) {
  //  auth.handleAuthentication();
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
// this.sessionUserId = this.gfunc.currentUserVAR.user_id;
// this.sessionUsername = this.gfunc.currentUserVAR.username;
// this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));







  }

  toggleNavigation(): void {
    jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

ngOnChanges():  void {
  //  // Do a little pause to get the status.
  //  this.getBrandUser(this.gfunc.sessionUserId)
}

  ngOnInit() {
    this.appVersionService.checkForVersionMismatch();

    this.routerEventsSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.appVersionService.checkForVersionMismatch();
      });

    if (this.showLegalClock) {
      this.updateLegalClock();
      this.legalClockTimer = setInterval(() => {
        this.updateLegalClock();
      }, 1000);
    }




    // this.force_logout = 0;

    // Do a little pause to get the status.
    // this.getBrandUser(this.gfunc.sessionUserId)


// check if the user has tfa enabled and does not have the this.gfunc.tfa_code_in_use must set


// And add the two routes othwise completely log the user out.....
if( this.gfunc.tfa_code_in_use != 1 && ( 
  this.all_router_details != '/admin' &&
  this.all_router_details != '/staff' &&
  this.all_router_details != '/agent' &&
  this.all_router_details != '/client'
)){
  // alert('Good Try, but you cannot do that, we have logged you out!')
  // this.gfunc.logout(); // SWICHED THIS SHITE OFF>...
}

    // new function set in top nav
    // **** June 2020 new security protocols... the app logs out if at idle after 10 mins.
    // :: @ https://blog.bitsrc.io/how-to-implement-idle-timeout-in-angular-af61eefdb13b
    // :: @ https://stackblitz.com/edit/idle-timer?file=app%2Fapp.component.html
    // Testing the idle function scropt
             

              // test
              // this.idleService.init(60); // in seconds; // 10 mins = 600 seconds at idle
              this.idleService.getSeconds();
              this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle

              // see if I can initiate the timer code I already have.
                      // if(this.force_logout == 1){
                      //   // if(this.gfunc.sessionUserId == '108'){
                      //   this.idleService.init(0); // FLO
                      //   // or kill and go direct and fource this user to logout.
                      //   // this.gfunc.login();
                      
                      // } else{
                      //   this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle
                      // }


  }

  ngOnDestroy(): void {
    if (this.legalClockTimer) {
      clearInterval(this.legalClockTimer);
    }

    if (this.routerEventsSub) {
      this.routerEventsSub.unsubscribe();
    }
  }
  
  resetTimer(){
    console.log('button');
    // this is possible but with the global event not needed
    // this.idleService.resetCount();
  }

  printSeconds(){
    console.log(this.idleService.getSeconds());
  }

  toggleShow() {
    this.isShown = ! this.isShown;
    }


    // show to all users
  get showLegalClock(): boolean {
    return Number(this.gfunc.sessionUserLevel) <= 4;
  }

  private updateLegalClock(): void {
    const now = new Date();
    this.legalNowDate = this.legalDate.format(now, 'ddd D MMM YYYY');
    this.legalNowTime = this.legalDate.format(now, 'h:mm:ss a');
    this.userNowDateTime = new Intl.DateTimeFormat('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).format(now);
  }



    public toggleShow_help() {
      this.isShown_help =! this.isShown_help;
      console.log('toggling');
      }
   public   toggleShow_help_vars() {
        this.isShown_help_vars = ! this.isShown_help_vars;
        }
     public   toggleShow_help_routes() {
          this.isShown_help_routes = ! this.isShown_help_routes;
          }


// Database Functions
getBrandUser(user_id) {
  this._demoService.getBrandUser(user_id).subscribe(
     data => { this.brand_user = data;
    let res = data[0];
    this.force_logout = res.force_logout;


            // ######  FORCE LOGOUT
              // // see if I can initiate the timer code I already have.
              // if(this.force_logout == 1){
              //   // if(this.gfunc.sessionUserId == '108'){
              //   this.idleService.init(0); // FLO
              //   // or kill and go direct and fource this user to logout.
              //   // this.gfunc.login();
              
              // } else{
              //   this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle
              // }


    },
     err => console.error(err),
     () => console.log('done loading user for update')
   );
 }






}
